<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">币安合约</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>合约配置</el-breadcrumb-item>

            <el-button style="float: right" type="primary" @click="syncConfig">同步配置</el-button>
        </el-breadcrumb>


        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-bottom: 10px">
            <el-tab-pane label="USDT合约" name="USDT"></el-tab-pane>
            <el-tab-pane label="币本位合约" name="COIN"></el-tab-pane>
        </el-tabs>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="symbol" label="交易对" show-overflow-tooltip></el-table-column>
            <el-table-column prop="pair" label="标的交易对" show-overflow-tooltip></el-table-column>
            <el-table-column prop="contractType" label="合约类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="baseAsset" label="标的资产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="quoteAsset" label="报价资产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="marginAsset" label="保证金资产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="pricePrecision" label="价格小数点位数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="quantityPrecision" label="数量小数点位数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="baseAssetPrecision" label="标的资产精度" show-overflow-tooltip></el-table-column>
            <el-table-column prop="quotePrecision" label="报价资产精度" show-overflow-tooltip></el-table-column>
            <el-table-column label="maker/taker" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.makerAdjustment}} / {{scope.row.takerAdjustment}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" show-overflow-tooltip></el-table-column>
            <el-table-column label="是否展示" fixed="right">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.display" active-color="#13ce66" inactive-color="#ff4949"
                               @change="displaySymbol(scope.row.id,$event)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="是否可下单" fixed="right">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.createOrder" active-color="#13ce66" inactive-color="#ff4949"
                               @change="canCreateOrder(scope.row.id,$event)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="是否可撤销订单" fixed="right">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.cancelOrder" active-color="#13ce66" inactive-color="#ff4949"
                               @change="canCancelOrder(scope.row.id,$event)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="是否返佣" fixed="right">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.rebate" active-color="#13ce66" inactive-color="#ff4949"
                               @change="canRebate(scope.row.id,$event)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="是否同步数据" fixed="right">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.syncTrade" active-color="#13ce66" inactive-color="#ff4949"
                               @change="canSyncTrade(scope.row.id,$event)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="220px">
                <template slot-scope="scope">
                    <el-button type="primary" @click="seeDetail(scope.row)">详情</el-button>
                    <el-button type="danger" @click="updateFeeAdjustmentDialog(scope.row)">手续费修改</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :visible.sync="detailDialogVisible" title="配置详情" width="1200px" @close="clearDataOne">
            <el-form style="width: 100%" inline>
                <el-form-item label="ID：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.id}}</span>
                </el-form-item>
                <el-form-item label="交易对：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.symbol}}</span>
                </el-form-item>
                <el-form-item label="标的交易对：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.pair}}</span>
                </el-form-item>
                <el-form-item label="合约类型：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.contractType}}</span>
                </el-form-item>
                <el-form-item label="标的资产：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.baseAsset}}</span>
                </el-form-item>
                <el-form-item label="报价资产：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.quoteAsset}}</span>
                </el-form-item>
                <el-form-item label="保证金资产：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.marginAsset}}</span>
                </el-form-item>
                <el-form-item label="价格小数点位数：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.pricePrecision}}</span>
                </el-form-item>
                <el-form-item label="数量小数点位数：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.quantityPrecision}}</span>
                </el-form-item>
                <el-form-item label="标的资产精度：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.baseAssetPrecision}}</span>
                </el-form-item>
                <el-form-item label="报价资产精度：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.quotePrecision}}</span>
                </el-form-item>
                <el-form-item label="标的类型：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.underlyingType}}</span>
                </el-form-item>
                <el-form-item label="开启priceProtect的条件订单的触发阈值：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.triggerProtect}}</span>
                </el-form-item>
                <el-form-item label="USDT合约或者币本位合约：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.usdtOrCoin}}</span>
                </el-form-item>
                <el-form-item label="maker/taker：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.makerAdjustment}} / {{configDetail.takerAdjustment}}</span>
                </el-form-item>
                <el-form-item label="USDT合约或者币本位合约：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.contractBaseType}}</span>
                </el-form-item>
                <el-form-item label="状态：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.status}}</span>
                </el-form-item>
                <el-form-item label="是否展示：" style="margin-right: 10px;width: 350px">
                    <el-switch :value="configDetail.display" active-color="#13ce66" inactive-color="#ff4949"
                               disabled></el-switch>
                </el-form-item>
                <el-form-item label="是否可下单：" style="margin-right: 10px;width: 350px">
                    <el-switch :value="configDetail.createOrder" active-color="#13ce66" inactive-color="#ff4949"
                               disabled></el-switch>
                </el-form-item>
                <el-form-item label="是否可撤销订单：" style="margin-right: 10px;width: 350px">
                    <el-switch :value="configDetail.cancelOrder" active-color="#13ce66" inactive-color="#ff4949"
                               disabled></el-switch>
                </el-form-item>
                <el-form-item label="是否返佣：" style="margin-right: 10px;width: 350px">
                    <el-switch :value="configDetail.rebate" active-color="#13ce66" inactive-color="#ff4949"
                               disabled></el-switch>
                </el-form-item>
                <el-form-item label="是否同步数据：" style="margin-right: 10px;width: 350px">
                    <el-switch :value="configDetail.syncTrade" active-color="#13ce66" inactive-color="#ff4949"
                               disabled></el-switch>
                </el-form-item>
                <el-form-item label="上线日期：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.onboardDate | moment}}</span>
                </el-form-item>
                <el-form-item label="交割日期：" style="margin-right: 10px;width: 350px">
                    <span>{{configDetail.deliveryDate | moment}}</span>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="detailDialogVisible==false">关 闭</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="dialogVisible" title="手续费修改" width="500px" @close="clearData">
            <div style="color: red">* 确认修改手续费调整，如果设置过调整值，请先联系技术清除已有调整值</div>
            <el-form label-width="150px" :model="updateData" :rules="updateRules" ref="updateForm" style="margin-top: 20px">
                <el-form-item label="maker调整值：" prop="makerAdjustment">
                    <el-input v-model="updateData.makerAdjustment" placeholder="maker调整值"
                              style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="taker调整值：" prop="takerAdjustment">
                    <el-input v-model="updateData.takerAdjustment" placeholder="taker调整值"
                              style="width: 300px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible==false">关 闭</el-button>
                <el-button type="danger" @click="updateFeeAdjustment">修 改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'SymbolConfig',
        components: {},
        data() {
            return {
                activeName: "USDT",
                dataList: [],
                detailDialogVisible: false,
                dialogVisible: false,
                configDetail: {},
                updateData: {
                    id: "",
                    makerAdjustment: "",
                    takerAdjustment: "",
                },
                updateRules: {
                    "makerAdjustment": [{required: true, message: "请输入maker"}],
                    "takerAdjustment": [{required: true, message: "请输入taker"}]
                }
            }
        },
        methods: {
            handleClick(tab, event) {
                this.getContractSymbolConfigList();
            },
            getContractSymbolConfigList() {
                api.getContractSymbolConfigList({contractBaseType: this.activeName}).then(({data}) => {
                    this.dataList = data;
                });
            },
            syncConfig() {
                this.$confirm('确认同步配置吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.synchronizeAllSymbol().then(({req}) => {
                        this.$message.success('同步成功！');
                    });
                }).catch(() => {
                });
            },
            displaySymbol(id, status) {
                api.displaySymbol({id: id, display: status}).then(({req}) => {
                    this.getContractSymbolConfigList();
                    this.$message.success('操作成功！');
                });
            },
            canCreateOrder(id, status) {
                api.canCreateOrder({id: id, canCreateOrder: status}).then(({req}) => {
                    this.getContractSymbolConfigList();
                    this.$message.success('操作成功！');
                });
            },
            canCancelOrder(id, status) {
                api.canCancelOrder({id: id, canCancelOrder: status}).then(({req}) => {
                    this.getContractSymbolConfigList();
                    this.$message.success('操作成功！');
                });
            },
            canRebate(id, status) {
                api.canRebate({id: id, isRebate: status}).then(({req}) => {
                    this.getContractSymbolConfigList();
                    this.$message.success('操作成功！');
                });
            },
            canSyncTrade(id, status) {
                api.canSyncTrade({id: id, syncTrade: status}).then(({req}) => {
                    this.getContractSymbolConfigList();
                    this.$message.success('操作成功！');
                });
            },
            seeDetail(row) {
                this.configDetail = row;
                this.detailDialogVisible = true;
            },
            updateFeeAdjustmentDialog(row) {
                this.updateData = {
                    id: row.id,
                    makerAdjustment: row.makerAdjustment,
                    takerAdjustment: row.takerAdjustment,
                };
                this.dialogVisible = true;
            },
            updateFeeAdjustment() {
                this.$refs["updateForm"].validate(valid => {
                    if (valid) {
                        api.updateFeeAdjustment(this.updateData).then(({data}) => {
                            this.$message.success('保存成功！');
                            this.getContractSymbolConfigList();
                            this.dialogVisible = false;
                        });
                    }
                });
            },
            clearDataOne() {
                this.configDetail = {};
            },
            clearData() {
                this.updateData = {
                    id: "",
                    makerAdjustment: "",
                    takerAdjustment: "",
                };
            }
        },
        created() {
            this.getContractSymbolConfigList();
        }
    };
</script>

<style lang="less" scoped>

</style>

